<div
  class="filter-select-container"
  [class.maintain-filter-width]="isSearchable && maintainFilterWidth"
  [class.search-placeholder]="isSearchable && isExpanded"
>
  <div
    class="filter-select"
    [ngClass]="[
      (isMulti ? control.value?.length > 0 : control.value) ? 'has-selection' : '',
      (isMulti && control.value?.length > 1 ? 'multiple-selections' : '')
    ]"
    (mousedown)="expandClickMenu($event)"
  >
    <div class="filter-select-content">
      <input
        [id]="formControlName + '-select'"
        [ngClass]="[
          (control.touched | isControlInvalidAndTouched:control.invalid) ? 'invalid' : '',
          formControlName + '-filter-select'
        ]"
        [placeholder]="isExpanded && isSearchable ? 'Select or start typing...' : placeholder"
        [value]="isSearchable && isSearching() ? searchQuery() : (selectionDisplayName() || '')"
        [attr.readonly]="!isSearchable || !isExpanded ? true : null"
        (input)="isSearchable ? onInputChange($event) : null"
        (focus)="onInputFocus($event)"
        (keydown)="handleKeyDown($event)"
        (keyup.escape)="escapeMenu($event)"
        [attr.aria-describedby]="formControlName && (control.touched | isControlInvalidAndTouched:control.invalid) ? formControlName + '-error-messages' : null"
        [attr.aria-expanded]="isExpanded"
        [attr.aria-invalid]="control.touched | isControlInvalidAndTouched:control.invalid"
        [attr.required]="(control | isControlRequired) || null"
        [attr.aria-labelledby]="ariaLabelledBy || null"
        [attr.aria-label]="ariaLabelledBy ? null : placeholder + (selectionDisplayName() ? ' ' + selectionDisplayName() : '') + (!isSearchable ? ' (read only)' : '')"
        aria-haspopup="listbox"
        [attr.aria-readonly]="!isSearchable || !isExpanded"
        [disabled]="control.disabled"
        [size]="size"
        [attr.autocomplete]="'off'"
        tabindex="0"
        #input
      >


      <!-- Error Messages -->
      @if (shouldShowErrors) {
        <div
          class="filter-select-error-messages"
          [attr.id]="formControlName + '-error-messages'"
          aria-live="assertive"
        >
          @for (errorMessage of errorMessagesToDisplay; track errorMessage) {
            <div class="filter-select-error-message">
              {{ errorMessage }}
            </div>
          }
        </div>
      }
    </div>

    @if (isMulti && controlValueLength() > 1 && !isSearching()) {
      <span class="filter-select-overflow-count">
        {{ controlValueLength() }}
      </span>
    }

    <div class="filter-select-icon">
      @if (!isSearching()) {
        @if ((isMulti && controlValueLength() >= 1) || (!isMulti && !!control.value && !isRequired)) {
          <iris-icon-button
            class="clear-value-icon"
            icon="close"
            [attr.data-test]="'clear-value-' + placeholder"
            [type]="irisIconButtonTypes.TERTIARY"
            [typeAttribute]="irisButtonTypeAttributeOptions.BUTTON"
            [iconSize]="iconSizes.SM"
            ariaLabel="Clear search"
            data-test="clear-search"
            (click)="clearSelection($event)"
          >
          </iris-icon-button>
        } @else if (isExpanded) {
          <iris-icon
            [name]="collapseIcon"
            class="filter-select-toggle"
            [size]="iconSizes.MD"
            [usage]="iconUsageTypes.DECORATIVE"
            [color]="iconColors.BLACK"
          ></iris-icon>
        } @else if (!isExpanded) {
          <iris-icon
            [name]="expandIcon"
            class="filter-select-toggle"
            [size]="iconSizes.MD"
            [usage]="iconUsageTypes.DECORATIVE"
            [color]="iconColors.BLACK"
          ></iris-icon>
        }
      }
    </div>
  </div>
</div>

@if (isExpanded) {
  <div
    class="filter-select-dropdown"
    [class.right-aligned]="alignRight"
    [class.match-field-width]="matchFieldWidth"
    data-test="filter-insurance"
  >
    <div class="filter-select-inner-container">
      @for (category of filteredOptions(); track category; let categoryIndex = $index) {
        @if (category.options.length > 0) {
          <ul>
            @if (category.name) {
              <div class="category-label">
                {{ category.name }}
              </div>
            }
            @for (option of category.options; track option; let optionIndex = $index) {
              <li
                class="filter-select-list-item"
                data-test="select-list-item"
                [attr.data-test]="'filter-select-list-item-' + option.name"
                [id]="formControlName + '-select-option' + optionIndexMap().get(option)"
                (keydown)="handleKeyDown($event)"
                (keyup.escape)="escapeMenu($event)"
                (click)="onOptionClick(option, $event)"
                [attr.aria-label]="(category.name ? category.name + ': ' : '') + option.name"
                role="option"
                [class.single-selected]="!isMulti && control.value === option.value"
                tabindex="-1"
                #listItem
              >
                <div class="option-content">
                  @if (isMulti) {
                    <div
                      class="custom-radio"
                      [class.selected]="isMulti ? temporarySelectedValues.has(option.value) : control.value === option.value"
                    >
                      @if (isMulti ? temporarySelectedValues.has(option.value) : control.value === option.value) {
                        <div class="radio-inner"></div>
                      }
                    </div>
                  }
                  <span
                    class="filter-select-list-item-label"
                    [attr.data-test]="'select-list-item-label-' + option.name"
                  >
                    {{ option.name }}
                  </span>
                </div>
              </li>
            }
            @if (categoryIndex !== lastVisibleCategoryIndex()) {
              <div class="bottom-border"></div>
            }
          </ul>
        }
      }

      @if (hasNoOptions() && isSearching()) {
        <span class="filter-select-list-item disabled">
          No results found
        </span>
      } @else if (shouldShowEmptyOptionText()) {
        <span class="filter-select-list-item disabled empty-option-text">
          {{ emptyOptionText }}
        </span>
      }
    </div>

    <!-- Multi-select action buttons -->
    @if (isMulti && isExpanded) {
      <div class="filter-select-actions">
        <iris-button-container [alignment]="irisButtonContainerAlignments.END">
          @if (!isRequired) {
            <iris-button
              (click)="clearTemporarySelections()"
              [buttonType]="irisButtonTypes.TERTIARY"
              [attr.data-test]="'clear-selections-' + formControlName"
              [typeAttribute]="clearButtonType"
              #clearButton
            >
              Clear
            </iris-button>
          }
          <iris-button
            (click)="selectionAndCloseDropdown()"
            [buttonType]="irisButtonTypes.PRIMARY"
            [attr.data-test]="'see-results-' + formControlName"
          >
            Done
          </iris-button>
        </iris-button-container>
      </div>
    }
  </div>
}